import * as url from './url_helper';

// get Filter List
export const getFilterListPW = async () => {
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query{
    getFilterListPW(data: {
      userId: ${user.id || ''}})
      {
     name
     type
     data {
       id
       name
     }
   }
 }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.getFilterListPW;
};
export function getNames(list: []) {
  const listNames = list.map((obj: any) => {
    return `{name: "${obj.label}"}`;
  });
  return listNames.join();
}

export const getFilterDataPW = async (data: any) => {
  const { from, to, status, whLocation, comodityType, seller, brand, buyer } =
    data;

  const whLocationNames = getNames(whLocation);
  const comodityTypeNames = getNames(comodityType);
  const sellerNames = getNames(seller);
  const brandNames = getNames(brand);
  const buyerNames = getNames(buyer);
  const statusNames = getNames(status);

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
  getFilterDataPW(data: 
    {
      userId: ${user.id || ''},
      startDate: "${from || ''}",
      endDate: "${to || ''}",
      status: [ ${statusNames} ],      
      whLocation: [ ${whLocationNames} ],
      comodityType: [${comodityTypeNames}],
      seller: [${sellerNames}],
      brand: [${brandNames}],
      buyer: [${buyerNames}]
    })
    {
    sales {
      id
      title
      price
      isDoller
      postFix
      statusColor
      series
    }
    salesByLocation {
      id
      title
      percent
      value
      quantity
      latLng
    }
    amountOrdesBrand {
      series
      labels
      colors
    }
    orders {
      id
      key
      title
      price
      isDoller
      postFix
      statusColor
      series
      colors
      labels
    }
    ordersByCommodity {
      labels
      Profit
      Loss
      colors
    }
    recentActivity {
      id  
      name
      symbol
      symbolColor
      dateTime
      value
    }
  }
}
  `;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.getFilterDataPW[0];
};
